const heroSliderElement = document.querySelector('.main-hero .slideshow')
const SLIDE_STATIC_DURATION = 5000
const INITIAL_SLIDE_DELAY = 1500

if (heroSliderElement) {
	const slides = Array.from(
		heroSliderElement.querySelectorAll('.slideshow__slide')
	)

	if (!slides.length) {
		return
	}

	let currentIndex = 0
	let imageTimeoutId = null

	const clearImageTimeout = () => {
		if (imageTimeoutId !== null) {
			window.clearTimeout(imageTimeoutId)
			imageTimeoutId = null
		}
	}

	const setActiveSlide = (index) => {
		slides.forEach((slide, i) => {
			if (i === index) {
				slide.classList.add('is-active')
			} else {
				slide.classList.remove('is-active')
			}
		})
	}

	const goToNextSlide = () => {
		currentIndex = (currentIndex + 1) % slides.length
		playCurrentSlide()
	}

	const playCurrentSlide = () => {
		clearImageTimeout()

		const currentSlide = slides[currentIndex]
		if (!currentSlide) return

		setActiveSlide(currentIndex)

		const video = currentSlide.querySelector('video')

		if (video) {
			try {
				video.currentTime = 0
				const playPromise = video.play()
				if (playPromise && typeof playPromise.then === 'function') {
					playPromise.catch(() => {})
				}
			} catch (e) {
				// ignore
			}

			const handleEnded = () => {
				video.removeEventListener('ended', handleEnded)
				goToNextSlide()
			}

			video.addEventListener('ended', handleEnded, { once: true })
		} else {
			imageTimeoutId = window.setTimeout(() => {
				goToNextSlide()
			}, SLIDE_STATIC_DURATION)
		}
	}

		// start with first slide, but delay for CLS performance
		window.setTimeout(() => {
			setActiveSlide(currentIndex)
			heroSliderElement.classList.add('is-initialized')
			playCurrentSlide()
		}, INITIAL_SLIDE_DELAY)
}
